import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { CROSS_JOIN_NTH_USER_ONBOARDING } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

export const preloadCrossJoinNthUserOnboardingState = () => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [
				CROSS_JOIN_NTH_USER_ONBOARDING.TRENDING_PAGES,
				CROSS_JOIN_NTH_USER_ONBOARDING.DISMISSED,
			],
		},
	});
};
